import styled, { css } from 'styled-components';
import { animateSlideOutRight, animateSlideInRight } from './keyframes.js';
import { Box } from '../Box/Box.js';
import { Flex } from '../Flex/Flex.js';

const IconContainer = styled(Flex)(({ theme: { olist: { components: { toast }, }, }, variation = 'info', }) => css `
    background-color: ${toast.variation[variation]};
    border-radius: ${toast.padding};
  `);
const ToastItemContainer = styled(Box)(({ theme: { olist }, shouldHide }) => css `
    width: 360px;
    max-width: calc(100% - 16px);
    background-color: ${olist.components.toast['background-color']};
    padding: ${olist.components.toast.padding};
    border-radius: ${olist.components.toast.radius};
    border: ${olist.components.toast['border-width']} solid
      ${olist.components.toast['border-color']};
    box-shadow: ${olist.components.toast['box-shadow']};
    top: ${olist.spacing.stack.small};
    right: 0;

    ${shouldHide ? animateSlideOutRight : animateSlideInRight}
  `);
const ToastsContainer = styled(Flex)(({ theme: { olist } }) => css `
    position: fixed;
    z-index: 999999;
    flex-direction: column;
    align-items: flex-end;
    gap: ${olist.spacing.stack['1xsmall']};
    top: ${olist.spacing.stack.small};
    right: ${olist.spacing.stack.small};

    ${animateSlideInRight}
  `);

export { IconContainer, ToastItemContainer, ToastsContainer };
